import * as React from 'react'

import { AppBar, IconButton, Toolbar, Typography } from '@material-ui/core'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import SnackbarService from '../../../services/snackbars'

import { getColorInGradient } from '../../../services/colors'

import { EstimatedTime } from 'components'

import './style.scss'

interface IProps {
  backAction: (toMainPage?: boolean) => void
  activeQuestion: number
  questionsCount: number
  estimatedTime: number
  title: string
  setInRow: (callback: any) => void
}

interface IState {}

class TopBar extends React.Component<IProps, IState> {
  private static gradStart = '#6D1CF0'
  private static gradEnd = '#6D1CF0'

  onTimeClick = () => {
    const { estimatedTime } = this.props
    SnackbarService.showSnackbar(
      `This questionnaire typically takes ${estimatedTime} minutes to complete`,
      'info'
    )
  }

  render() {
    const {
      backAction,
      activeQuestion,
      questionsCount,
      estimatedTime,
      title
    } = this.props
    const value = ((activeQuestion + 1) / questionsCount) * 100
    return (
      <AppBar
        className="questions-page-header appbar"
        position="static"
        color="default"
      >
        <Toolbar className="question-page-header-toolbar question-page-header-toolbar-header">
          <EstimatedTime time={estimatedTime} onClick={this.onTimeClick} />
          <img
            // onClick={() => backAction(true)}
            onClick={() => this.props.setInRow(() => window.history.back())}
            src={require('../../../assets/img/closeIcon.svg')}
            className="icon"
          />
        </Toolbar>
        <Toolbar className="question-page-header-toolbar title">
          <Typography className="questionnaire-title">{title}</Typography>
        </Toolbar>
        <Toolbar className="question-page-header-toolbar progress">
          <div className="question-page-header-toolbar-top">
            <IconButton
              color="inherit"
              aria-label="Back"
              className="back-icon-btn icon-btn back"
              onClick={() => backAction()}
            >
              <ArrowBackIos className="back-icon" />
            </IconButton>

            <div className="progress-status">
              <span className="value done">{activeQuestion + 1}</span>
              <span className="divider">/</span>
              <span className="value available">{questionsCount}</span>
            </div>
          </div>
          <div className="question-progress-container">
            <div className="question-progress">
              <div
                className="question-progress-value"
                style={{
                  width: `${value}%`,
                  backgroundImage: `linear-gradient(to right, ${
                    TopBar.gradStart
                  }, ${getColorInGradient(
                    value,
                    TopBar.gradStart,
                    TopBar.gradEnd
                  )})`
                }}
              />
            </div>
          </div>
        </Toolbar>
      </AppBar>
    )
  }
}

export default TopBar



// WEBPACK FOOTER //
// ./src/pages/Questionnaires/TopBar/index.tsx